import Numeral from './numeral.vue';
export default Numeral;


// WEBPACK FOOTER //
// ./src/components/numeral/index.js